/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Who_FreeInputs */

const en_cp_who_free = /** @type {(inputs: Cp_Who_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecturers, problem owners and mentors are always free as client viewers — no seat limit.`)
};

const id_cp_who_free = /** @type {(inputs: Cp_Who_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dosen, pemilik masalah, dan mentor selalu gratis sebagai client viewer — tanpa batas jumlah.`)
};

/**
* | output |
* | --- |
* | "Lecturers, problem owners and mentors are always free as client viewers — no seat limit." |
*
* @param {Cp_Who_FreeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_who_free = /** @type {((inputs?: Cp_Who_FreeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Who_FreeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_who_free(inputs)
	return en_cp_who_free(inputs)
});